import { createContext, useContext, useMemo } from 'react';

import { createOnfidoIntegration } from '@endeavour/onfido';
import type { IVerificationInterface } from '@endeavour/verification-integration';

import type { FCWithChildren } from '../../shared/utils/component.interface';

const VerificationContext = createContext<IVerificationInterface<unknown>>({
    initialize: () => {
        throw new Error('Context not set up!');
    },
});

export const VerificationContextProvider: FCWithChildren<unknown> = ({ children }) => {
    const verificationIntegration = useMemo(() => createOnfidoIntegration(), []);

    return (
        <VerificationContext.Provider value={verificationIntegration}>
            {children}
        </VerificationContext.Provider>
    );
};

export function useVerificationProvider() {
    return useContext(VerificationContext);
}
